import { useNavigate, useParams, useLocation, useOutletContext } from 'react-router-dom';
import CallRegistryModalForm from './CallRegistryModalForm';

export default function CallRegistryModalFormRoute() {
  const navigate = useNavigate();
  const { id } = useParams();
  const location = useLocation();
  const context = useOutletContext<any>();
  const preSelectedDeals = location.state?.deals || [];

  const handleClose = () => {
    navigate(`/communication/contact/${id}/page-view`);
  };

  const handleSuccess = (newActivity: any) => {
    if (context?.onInteractionCreated) {
      context.onInteractionCreated(newActivity);
    }
    context?.onDealSelectionChange?.(new Set());
    navigate(`/communication/contact/${id}/page-view`, { replace: true });
  };

  const handleDealsChange = (deals: any[]) => {
    context?.onDealSelectionChange?.(new Set(deals.map((d: any) => d.id)));
  };

  return (
    <CallRegistryModalForm
      contactId={id!}
      availableDeals={context?.contact?.deals || []}
      preSelectedDeals={preSelectedDeals}
      onClose={handleClose}
      onSuccess={handleSuccess}
      onDealsChange={handleDealsChange}
    />
  );
}
